import { NOTIFICATION_SEVERITY } from '../const/notification-severity.const'
import type { Notification } from '../types/notification.type'
import type { NotificationSeverity } from '../types/notification-severity.type'

const severityOrder: Record<NotificationSeverity, number> = {
  [NOTIFICATION_SEVERITY.CRITICAL]: 0,
  [NOTIFICATION_SEVERITY.WARNING]: 1,
  [NOTIFICATION_SEVERITY.INFO]: 2,
}

export const sortNotificationsBySeverity = (notifications: Notification[]): Notification[] =>
  [...notifications].sort((left, right) => {
    const severityDiff = severityOrder[left.severity] - severityOrder[right.severity]
    if (severityDiff !== 0) return severityDiff

    if (left.isRead !== right.isRead) {
      return left.isRead ? 1 : -1
    }

    return 0
  })
